const parseJsonField = (value, fallback) => {
  if (value == null) return fallback;
  if (Array.isArray(value) || typeof value === "object") return value;
  if (typeof value === "string") {
    try {
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  }
  return fallback;
};

const parseContentHtml = (content) => {
  if (!content) return "";
  if (typeof content === "object" && content.html !== undefined) {
    return content.html || "";
  }
  if (typeof content === "string") {
    try {
      const obj = JSON.parse(JSON.parse(content));
      return obj.html || "";
    } catch {
      try {
        const obj = JSON.parse(content);
        if (obj && typeof obj === "object" && obj.html !== undefined) {
          return obj.html || "";
        }
      } catch {
        return content;
      }
    }
  }
  return "";
};

const parseParticipant = (p) => ({
  slug: p.slug,
  name: p.name || "",
  profileImage: p.profileImage || "",
  intro: p.intro || "",
  goal: p.goal ?? 0,
  raised: p.raised ?? 0,
  content: parseContentHtml(p.content),
});

export function parseFundraiser(data) {
  if (!data) return null;

  const participantsRaw = parseJsonField(data.participants, []);
  const participants = Array.isArray(participantsRaw)
    ? participantsRaw.map(parseParticipant)
    : [];

  return {
    slug: data.fundraiserId,
    title: data.title || "",
    description: data.description || "",
    heroImage: data.image || "",
    goal: data.goalAmount ?? 0,
    raised: data.raisedAmount ?? 0,
    content: parseContentHtml(data.mainContent),
    tournamentDetails: parseJsonField(data.tournamentDetails, []),
    participants,
  };
}
